// extracted by mini-css-extract-plugin
module.exports = {"content":"SykmeldtSide_content__Yp_HN","innercontent":"SykmeldtSide_innercontent__0sPD_"};